
export class UserApi {
    id: number;
    nome: string;
    senha: string;
    email: string;
    fotoURL: string;
    emailValido: boolean;
}
